export default "__VITE_ASSET__7c234c93__"